import { API_BASE_URL } from './config.js';
import fetchWrapper from '../components/utility/fetchWrapper.js';
import { useCallback } from 'react';

export const dashboardApi = {
  // Get all datasources
  getDatasources: async () => {
    const response = await fetchWrapper(`${API_BASE_URL}/api/v1/datasources`);
    if (!response.ok) throw new Error("Failed to fetch datasources");
    return await response.json();
  },

  // Search metrics
  searchMetrics: async (search = '') => {
    const url = search 
      ? `${API_BASE_URL}/api/v1/prometheus/metrics?search=${encodeURIComponent(search)}`
      : `${API_BASE_URL}/api/v1/prometheus/metrics`;
    const response = await fetchWrapper(url);
    if (!response.ok) throw new Error("Failed to fetch metrics");
    return await response.json();
  },

  // Get labels for a metric (returns labels array for that metric)
  getMetricLabels: async (metric) => {
    const response = await fetchWrapper(
      `${API_BASE_URL}/api/v1/prometheus/metrics/${encodeURIComponent(metric)}/labels`
    );
    if (!response.ok) throw new Error("Failed to fetch metric labels");
    return await response.json();
  },

  // Get all available label names
  getLabelNames: async () => {
    try {
      const response = await fetchWrapper(
        `${API_BASE_URL}/api/v1/prometheus/metrics/__name__/labels`
      );
      if (!response.ok) return [];
      const res = await response.json();
      return res?.data?.labels || [];
    } catch {
      return [];
    }
  },

  // Get values for a label
  getLabelValues: async (labelName) => {
  try {
    const response = await fetchWrapper(`${API_BASE_URL}/api/v1/prometheus/labels/${labelName}/values`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    const data = await response.json();
    console.log('getLabelValues response:', data);
    return data;
  } catch (error) {
    console.error('getLabelValues error:', error);
    throw error;
  }},

  // Execute query
  executeQuery: async (queryData) => {
    const response = await fetchWrapper(
      `${API_BASE_URL}/api/v1/prometheus/query/execute`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(queryData),
      }
    );
    if (!response.ok) throw new Error("Failed to execute query");
    return await response.json();
  },

  // List all dashboards
listDashboards: async (includeDashboard = false) => {
  const url = `${API_BASE_URL}/api/v1/dashboards?include_dashboard=${includeDashboard}`;
  const response = await fetchWrapper(url);
  if (!response.ok) throw new Error("Failed to list dashboards");
  return await response.json();
},

// Get specific dashboard
getDashboardByName: async (dashboardName) => {
  const response = await fetchWrapper(
    `${API_BASE_URL}/api/v1/dashboards/${encodeURIComponent(dashboardName)}`
  );
  if (!response.ok) throw new Error("Failed to get dashboard");
  return await response.json();
},

// Create new dashboard
createDashboard: async (dashboardName, dashboardJSON) => {
  const response = await fetchWrapper(
    `${API_BASE_URL}/api/v1/dashboards`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        dashboardName: dashboardName,
        dashboard: dashboardJSON
      })
    }
  );
  if (!response.ok) throw new Error("Failed to create dashboard");
  return await response.json();
},

// Update existing dashboard
updateDashboard: async (dashboardName, dashboardJSON) => {
  const response = await fetchWrapper(
    `${API_BASE_URL}/api/v1/dashboards/${encodeURIComponent(dashboardName)}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        dashboardName: dashboardName,
        dashboard: dashboardJSON
      })
    }
  );
  if (!response.ok) throw new Error("Failed to update dashboard");
  return await response.json();
},

// Delete dashboard
deleteDashboard: async (dashboardName) => {
  const response = await fetchWrapper(
    `${API_BASE_URL}/api/v1/dashboards/${encodeURIComponent(dashboardName)}`,
    {
      method: "DELETE"
    }
  );
  if (!response.ok) throw new Error("Failed to delete dashboard");
  return await response.json();
},


};